import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import links from '../../../config/locales/links';

import {
  AuthOuterWrapper,
  Form,
  ErrorWrapper,
  AuthHeader,
  HeaderImg,
  HeaderText,
  FooterLinkWrapper,
  FooterLink,
  FooterWrapper,
} from './AuthWrappers';
import { withStyles } from '@material-ui/core/styles';
import CustomizedButton from '../../Buttons/CustomizedButton';
import CssTextField from '../../Inputs/CssTextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TeamworkImg from '../../../assets/vectors/mirage-teamwork.png';

const CustomCheckbox = withStyles({
  root: {
    fontSize: '0.8rem',
    color: '#f3c314',
    '&$checked': {
      color: '#f3c314',
    },
  },
  checked: {},
})((props) => <Checkbox color='default' {...props} />);

const SignUp = ({ lang, passSignUpCall, error }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [checked, setChecked] = useState(false);

  const onSignUp = () => {
    passSignUpCall(email, password, confirmPassword, checked);
  };

  return (
    <AuthOuterWrapper>
      <AuthHeader>
        <HeaderImg src={TeamworkImg} alt='join-img' />
        <HeaderText>
          <FormattedMessage id='signup.form' />
        </HeaderText>
      </AuthHeader>
      <ErrorWrapper show={error} severity='error'>
        {error ? <FormattedMessage id={error} /> : ''}
      </ErrorWrapper>
      <Form onSubmit={() => onSignUp()}>
        <CssTextField
          label={<FormattedMessage id='signup.form-email' />}
          setValue={(e) => setEmail(e.target.value)}
          width='100%'
        />
        <CssTextField
          label={<FormattedMessage id='signup.form-password' />}
          setValue={(e) => setPassword(e.target.value)}
          inputType='password'
        />
        <CssTextField
          label={<FormattedMessage id='signup.form-confirm' />}
          setValue={(e) => setConfirmPassword(e.target.value)}
          inputType='password'
        />
        <FormControlLabel
          style={{ margin: '0.25rem 1rem' }}
          control={
            <CustomCheckbox
              checked={checked}
              onChange={() => setChecked(!checked)}
              value={checked}
            />
          }
          label={<FormattedMessage id='signup.form-agree-terms' />}
        />
      </Form>
      <CustomizedButton customButtonClicked={() => onSignUp()} style={{ margin: '1rem' }}>
        <FormattedMessage id='signup.form-button' />
      </CustomizedButton>
      <FooterWrapper center>
        <FooterLinkWrapper>
          <FooterLink href={links[lang]['terms-of-service']} target='_blank'>
            <FormattedMessage id='signup.form-see-terms' />
          </FooterLink>
        </FooterLinkWrapper>
        <FooterLinkWrapper right>
          <FooterLink href={links[lang]['privacy-policy']} target='_blank'>
            <FormattedMessage id='signup.form-see-policy' />
          </FooterLink>
        </FooterLinkWrapper>
      </FooterWrapper>
    </AuthOuterWrapper>
  );
};

export default SignUp;
